import { httpServer as http } from "@/lib/axios";
import { httpServer as downFilehttp } from "@/lib/downFileAxios";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 授权密码验证
    async validFinancialSecurityPwd({ rootState }, params = {}) {
      const data = await http(
        "/credit/manage/validFinancialSecurityPwd",
        params
      );
      return data ? data.data : false;
    },
    // 调整信用金额度
    async updateCreditLimit({ rootState }, params = {}) {
      const data = await http(
        "/credit/manage/updateCreditLimit",
        params
      );
    },
    // 调整信用金欠款
    async updateCreditDebt({ rootState }, params = {}) {
      const data = await http(
        "/credit/manage/updateCreditDebt",
        params
      );
    },
    // 添加新接口用于修改财务密码
    async updateShopFinancialPassword({ rootState }, params = {}) {
      const data = await http(
        "/k1/shop-info/updateShopFinancialPassword",
        params
      );
    },
    // 发送验证码
    async sendSms({ rootState }, params = {}) {
      const data = await http(
        "/k1/shop-info/sendSms",
        params
      );

    },
    // 信用金记账明细页：start
    // 列表
    async queryCreditLogList({ rootState }, params = {}) {
      const data = await http(
        "/k2/creditlog/queryCreditLogList",
        params
      );
      return data.data || { list: [], total: 0 };
    },
    // 导出
    async exportCreditLog({ rootState }, params = {}) {

      const data = await http(
        "/k2/creditlog/exportCreditLog",
        params
      );

      return data ? data.data : '';
    },
  }
};
